export const SetSelectPromotionDiscount = () => {
    return [
        // {
        //     label: 'Miễn phí vận chuyển',
        //     value: 'free-shipping',
        // },
        {
            label: 'Giảm giá theo tổng giá trị đơn hàng',
            value: 'total-order-value',
        },
        {
            label: 'Giảm giá theo sản phẩm / Combo',
            value: 'one-product',
        },
        {
            label: 'Giảm giá theo số lượng sản phẩm',
            value: 'quantity-product',
        },
        {
            label: 'Giảm giá theo danh mục sản phẩm / Combo',
            value: 'one-type-product',
        },
        {
            label: 'Giảm giá theo số lượng danh mục',
            value: 'quantity-type-product',
        },
        {
            label: 'Giảm giá theo mốc tích điểm của khách hàng',
            value: 'customer-accrual-points',
        },
        {
            label: 'Giảm giá theo nhóm khách hàng (VIP, Bạc, Vàng)',
            value: 'customer-group-discount',
        },
        {
            label: 'Giảm giá cho khách hàng mới / đơn hàng đầu tiên',
            value: 'first-order-discount',
        },
    ];
};

export const GetSelectPromotionDiscount = (time) => {
    if (time === 'total-order-value') {
        return {
            label: 'Tổng giá trị đơn hàng',
            value: 'total-order-value',
        };
    }
    if (time === 'one-product') {
        return {
            label: 'Từng sản phẩm / Combo',
            value: 'one-product',
        };
    }
    if (time === 'one-type-product') {
        return {
            label: 'Từng danh mục sản phẩm',
            value: 'one-type-product',
        };
    }
    if (time === 'quantity-product') {
        return {
            label: 'CK theo số lượng sản phẩm',
            value: 'quantity-product',
        };
    }
    if (time === 'quantity-type-product') {
        return {
            label: 'CK theo số lượng danh mục sản phẩm',
            value: 'quantity-type-product',
        };
    }
    if (time === 'customer-accrual-points') {
        return {
            label: 'CK theo mốc tích điểm của khách hàng',
            value: 'customer-accrual-points',
        };
    }
    if (time === 'customer-group-discount') {
        return {
            label: 'Giảm giá theo nhóm khách hàng (VIP, Bạc, Vàng)',
            value: 'customer-group-discount',
        };
    }
    if (time === 'first-order-discount') {
        return {
            label: 'Giảm giá cho khách hàng mới / đơn hàng đầu tiên',
            value: 'first-order-discount',
        };
    }

    return null;
};

export const SetSelectPromotionGift = () => {
    return [
        {
            label: 'Mua sản phẩm tặng sản phẩm',
            value: 'product-get-product',
        },
        {
            label: 'Tặng quà theo giá trị đơn hàng',
            value: 'total-order-value-get-product',
        },
        {
            label: 'Tặng quà theo mốc điểm của khách hàng',
            value: 'customer-accrual-points-get-product',
        },
    ];
};

export const GetSelectPromotionGift = (time) => {
    if (time === 'product-get-product') {
        return {
            label: 'Mua sản phẩm tặng sản phẩm',
            value: 'product-get-product',
        };
    }
    if (time === 'total-order-value-get-product') {
        return {
            label: 'Tặng quà theo giá trị đơn hàng',
            value: 'total-order-value-get-product',
        };
    }
    if (time === 'customer-accrual-points-get-product') {
        return {
            label: 'Tặng quà theo mốc điểm của khách hàng',
            value: 'customer-accrual-points-get-product',
        };
    }

    return null;
};
